
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import {Permissions} from "@/models/user-configs/permissions";
import {AuthService, UserConfigService} from "@/services";
import { MODULE } from "@/config/modules";
export default Vue.extend({
	data(){
		return {
			UserConfigService
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{value: this.$ct("products")}
			] as IBreadCrumb[];
		},
		isAdmin():boolean {
			return this.UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean=>{
				return permissions.IsAdmin;
			});
		},
		hasTaxModule():boolean {
			return AuthService.hasModule(MODULE.TAKSENVERWERKING);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
